import { Checkbox, makeStyles } from '@material-ui/core'
import { Stars } from '@material-ui/icons'
import React, { useCallback } from 'react'

export interface CustomsStyle {
  fullWidth: boolean | undefined
  backgroundColor: string | undefined
}
const useStyles = makeStyles(() => ({
  customIcon: {
    color: 'gold',
    backgroundColor: 'black',
    borderRadius: '50%',
    width: '2.5rem',
    height: '2.5rem',
    padding: '.2rem',
  },
  customsSelectContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: (props: CustomsStyle) => (typeof props.fullWidth !== 'undefined' ? '85%' : '6rem'),
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    backgroundColor: (props: CustomsStyle) =>
      typeof props.backgroundColor !== 'undefined' ? props.backgroundColor : 'black',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    height: '100%',
    margin: '0 auto',
  },
  customCheckBox: {
    padding: '.4rem',
    color: '#7d7b7b !important',
  },
}))

export interface OwnProps {
  onClick: (isChecked: boolean) => void
  currentChecked: boolean
  fullWidth?: boolean
  backgroundColor?: string
}

export type Props = OwnProps

const CustomCheckBox = ({ onClick, currentChecked, fullWidth, backgroundColor }: Props) => {
  const classes = useStyles({ fullWidth, backgroundColor })

  const handlOnChange = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onClick(checked)
    },
    [onClick]
  )

  return (
    <div className={classes.customsSelectContainer}>
      <Stars className={classes.customIcon} />
      <Checkbox
        inputProps={{ 'aria-label': 'primary checkbox' }}
        onChange={handlOnChange}
        checked={currentChecked}
        className={classes.customCheckBox}
      />
    </div>
  )
}
export default CustomCheckBox
